"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledIcon = exports.PasswrodChecklistWrapper = exports.PasswordCheck = exports.CheckWrapper = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _palette = require("../../styles/palette");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var PasswordCheck = exports.PasswordCheck = _styledComponents["default"].div.withConfig({
  displayName: "styles__PasswordCheck",
  componentId: "sc-m1s10d-0"
})(["width:20px;height:20px;border-radius:50%;text-align:center;background-color:", ";display:flex;justify-content:center;align-items:center;margin-right:10px;"], function (_ref) {
  var checked = _ref.checked;
  return checked ? _palette.commonPalette.brightGreen : _palette.commonPalette.disabledText;
});
var CheckWrapper = exports.CheckWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__CheckWrapper",
  componentId: "sc-m1s10d-1"
})(["display:flex;margin:10px 0 10px 15px;"]);
var StyledIcon = exports.StyledIcon = (0, _styledComponents["default"])(_Icon["default"]).attrs({
  style: {
    color: _palette.commonPalette.white,
    fontSize: 4
  }
}).withConfig({
  displayName: "styles__StyledIcon",
  componentId: "sc-m1s10d-2"
})(["width:", "px;height:", "px;"], function (_ref2) {
  var name = _ref2.name;
  return name === 'close' ? 10 : 18;
}, function (_ref3) {
  var name = _ref3.name;
  return name === 'close' ? 10 : 18;
});
var PasswrodChecklistWrapper = exports.PasswrodChecklistWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__PasswrodChecklistWrapper",
  componentId: "sc-m1s10d-3"
})(["margin:15px 0px 25px;"]);
//# sourceMappingURL=styles.js.map